// Not DRY'ed up for readability

export const BASE = '/app',
    ANYTIME_FEEDBACK_PROVIDE = '/anytime-feedback/provide/:requestId/:reviewerId?',
    ANYTIME_FEEDBACK_REQUEST_CREATE = '/anytime-feedback/request',
    ANYTIME_FEEDBACK_REQUEST_EDIT = '/anytime-feedback/request/:id',
    ANYTIME_FEEDBACK_GIVE_CREATE = '/anytime-feedback/give',
    DELETE_COMPANY = '/delete-company',
    SETTINGS = '/settings',
    SETTINGS_PRAISE = '/settings/praise',
    SETTINGS_MEETINGS = '/settings/meetings',
    SETTINGS_FEEDBACK = '/settings/feedback',
    SETTINGS_FEEDBACK_ANYTIME_GENERAL = '/settings/feedback/anytime-settings',
    SETTINGS_FEEDBACK_ANYTIME_AUTOMATIONS = '/settings/feedback/anytime-automations',
    SETTINGS_USERSETTINGS = '/settings/usersettings',
    SETTINGS_AI = '/settings/ai',
    SETTINGS_AI_FEATURES = '/settings/ai/features',
    SETTINGS_AI_COACHES = '/settings/ai/coaches',
    SETTINGS_AI_RESOURCES = '/settings/ai/coaches/resources',
    SETTINGS_AUTOMATIONS = '/settings/automations',
    SETTINGS_FEATURE_SELECTION = '/settings/feature-selection',
    SETTINGS_EMAIL_REPORTS = '/settings/email-reports',
    SETTINGS_MAIL_LOG = '/settings/mail-log/:companyId?',
    SETTINGS_BOUNCED_EMAILS = '/settings/bounced-emails',
    SETTINGS_MESSAGE_STATISTICS = '/settings/message-statistics/:companyId?',
    SETTINGS_MERGE_USERS = '/settings/merge-users/:sourceUserId?',
    SETTINGS_OBJECTIVE_CATEGORIES = '/settings/objective/categories',
    SETTINGS_OBJECTIVE_RATINGS = '/settings/objective/ratings',
    SETTINGS_PAYMENT_DETAILS = '/settings/payment-details',
    SETTINGS_BILLING = '/settings/billing',
    SETTINGS_CHECKOUT = '/settings/checkout',
    SETTINGS_CHECKOUT_STEP = '/settings/checkout/:defaultStep',
    SETTINGS_EMAILS = '/settings/emails',
    SETTINGS_HELPFUL_RESOURCES = '/settings/helpful-resources',
    SETTINGS_SAMPLE_CONTENT = '/settings/sample-content',
    SETTINGS_SAMPLE_CONTENT_PROGRESS = '/settings/sample-content-progress/:mode?',
    SETTINGS_HIP_CHAT = '/settings/hip-chat',
    SETTINGS_DESIGN = '/settings/design',
    SETTINGS_COMPANY = '/settings/company',
    SETTINGS_CUSTOM_WORDING = '/settings/custom-wording',
    SETTINGS_CSV = '/settings/import-users',
    SETTINGS_CSV_HISTORY = '/settings/import-users/history',
    SETTINGS_CSV_CONFIG = '/settings/import-users/config',
    SETTINGS_CSV_IMPORT = '/settings/import-users/import',
    SETTINGS_IMPORT = '/settings/automatic-user-import',
    SETTINGS_IMPORT_BAMBOO = '/settings/automatic-user-import/bamboo',
    SETTINGS_IMPORT_BAMBOO_HISTORY = '/settings/automatic-user-import/bamboo/history',
    SETTINGS_IMPORT_BAMBOO_PREVIEW = '/settings/automatic-user-import/bamboo/preview',
    SETTINGS_IMPORT_BAMBOO_CONFIG = '/settings/automatic-user-import/bamboo/config',
    SETTINGS_IMPORT_GOOGLE_WORKSPACE = '/settings/automatic-user-import/google-workspace',
    SETTINGS_IMPORT_GOOGLE_WORKSPACE_HISTORY = '/settings/automatic-user-import/google-workspace/history',
    SETTINGS_IMPORT_GOOGLE_WORKSPACE_PREVIEW = '/settings/automatic-user-import/google-workspace/preview',
    SETTINGS_IMPORT_GOOGLE_WORKSPACE_CONFIG = '/settings/automatic-user-import/google-workspace/config',
    SETTINGS_IMPORT_NAMELY = '/settings/automatic-user-import/namely',
    SETTINGS_IMPORT_NAMELY_HISTORY = '/settings/automatic-user-import/namely/history',
    SETTINGS_IMPORT_NAMELY_PREVIEW = '/settings/automatic-user-import/namely/preview',
    SETTINGS_IMPORT_NAMELY_CONFIG = '/settings/automatic-user-import/namely/config',
    SETTINGS_IMPORT_PERSONIO = '/settings/automatic-user-import/personio',
    SETTINGS_IMPORT_PERSONIO_HISTORY = '/settings/automatic-user-import/personio/history',
    SETTINGS_IMPORT_PERSONIO_PREVIEW = '/settings/automatic-user-import/personio/preview',
    SETTINGS_IMPORT_PERSONIO_CONFIG = '/settings/automatic-user-import/personio/config',
    SETTINGS_IMPORT_KALLIDUS = '/settings/automatic-user-import/kallidus',
    SETTINGS_IMPORT_KALLIDUS_HISTORY = '/settings/automatic-user-import/kallidus/history',
    SETTINGS_IMPORT_KALLIDUS_PREVIEW = '/settings/automatic-user-import/kallidus/preview',
    SETTINGS_IMPORT_KALLIDUS_CONFIG = '/settings/automatic-user-import/kallidus/config',
    SETTINGS_IMPORT_WORKDAY = '/settings/automatic-user-import/workday',
    SETTINGS_IMPORT_WORKDAY_HISTORY = '/settings/automatic-user-import/workday/history',
    SETTINGS_IMPORT_WORKDAY_PREVIEW = '/settings/automatic-user-import/workday/preview',
    SETTINGS_IMPORT_WORKDAY_CONFIG = '/settings/automatic-user-import/workday/config',
    SETTINGS_IMPORT_SFTP = '/settings/automatic-user-import/sftp',
    SETTINGS_IMPORT_SFTP_HISTORY = '/settings/automatic-user-import/sftp/history',
    SETTINGS_IMPORT_SFTP_CONFIG = '/settings/automatic-user-import/sftp/config',
    SETTINGS_IMPORT_CUSTOM_CSV = '/settings/automatic-user-import/custom-csv',
    SETTINGS_IMPORT_CUSTOM_CSV_HISTORY = '/settings/automatic-user-import/custom-csv/history',
    SETTINGS_IMPORT_CUSTOM_CSV_PREVIEW = '/settings/automatic-user-import/custom-csv/preview',
    SETTINGS_IMPORT_CUSTOM_CSV_CONFIG = '/settings/automatic-user-import/custom-csv/config',
    SETTINGS_IMPORT_WORKABLE = '/settings/automatic-user-import/workable',
    SETTINGS_IMPORT_WORKABLE_HISTORY = '/settings/automatic-user-import/workable/history',
    SETTINGS_IMPORT_WORKABLE_PREVIEW = '/settings/automatic-user-import/workable/preview',
    SETTINGS_IMPORT_WORKABLE_CONFIG = '/settings/automatic-user-import/workable/config',
    SETTINGS_CALENDAR_INTEGRATION = '/settings/calendar-integration',
    SETTINGS_SAML = '/settings/saml',
    SETTINGS_SLACK = '/settings/slack',
    AUDIT_LOG = '/observer/audit-log',
    SESSION_MANAGER = '/manage-user-sessions/:userId',
    DASHBOARD = '/home',
    DASHBOARD_ITEM = '/home/item/:itemId',
    INBOX = '/inbox',
    DOWNLOADS = '/downloads',
    ROLES = '/system-access-roles',
    MERGE_COMPANY = '/mergeCompany',
    COMPANY_ANALYTICS = '/labs/company-analytics/:companyId',
    ADMIN_INSIGHTS = '/admin/insights',
    INSIGHTS = '/insights',
    HR_AUTOMATIONS = '/admin/automations',
    EMPLOYEE_AUTOMATIONS = '/automations',
    FEEDBACK_PROVIDE = '/feedback/provide/:id',
    FEEDBACK_PREVIEW_ZEN = '/feedback-cycles/new-preview/:cycleId',
    FEEDBACK_USER = '/feedback',
    FEEDBACK_USER_FOR_YOU = '/feedback/for-you',
    FEEDBACK_USER_VIEW = '/feedback/view/:id',
    FEEDBACK_USER_VIEW_MULTIPLE = '/feedback/view-all/:id',
    FEEDBACK_USER_BY_YOU = '/feedback/by-you',
    FEEDBACK_USER_TODO = '/feedback/todo',
    FEEDBACK_USER_TEAM = '/feedback/team',
    FEEDBACK_USER_TEAM_ANYTIME = '/feedback/team/anytime',
    FEEDBACK_USER_TEAM_CYCLES = '/feedback/team/cycle',
    FEEDBACK_USER_TEAM_SINGLE_CYCLE = '/feedback/team/cycle/:managerId/:cycleId',
    FEEDBACK_USER_COMPANY = '/feedback/company',
    FEEDBACK_USER_COMPANY_ANYTIME = '/feedback/company/anytime',
    FEEDBACK_USER_COMPANY_CYCLES = '/feedback/company/cycle',
    FEEDBACK_USER_COMPANY_TEMPLATES = '/feedback/company/templates',
    FEEDBACK_USER_COMPANY_SINGLE_CYCLE = '/feedback/company/cycle/:cycleId',
    FEEDBACK_USER_COMPANY_CYCLE_CREATE = '/feedback/company/cycle/create',
    FEEDBACK_USER_COMPANY_CYCLE_EDIT = '/feedback/company/cycle/edit/:cycleId',
    FEEDBACK_USER_COMPANY_CYCLE_COPY = '/feedback/company/cycle/copy/:cycleId',
    MESSAGE_SINGLE = '/messages/:id',
    PRAISE_SINGLE = '/praise/:id',
    PRAISE_STREAM = '/praise',
    MEETING_PAGE = '/meetings/:userIds',
    MEETING_OVERVIEW = '/meetings',
    MEETING_OVERVIEW_YOUR = '/meetings/your',
    MEETING_OVERVIEW_TEMPLATE = '/meetings/template',
    MEETING_OVERVIEW_TEMPLATES = '/meetings/templates',
    MEETING_OVERVIEW_TEMPLATES_EDIT_PERSONAL = '/meetings/templates/personal/:templateId',
    MEETING_OVERVIEW_TEMPLATES_EDIT_COMPANY = '/meetings/templates/company/:templateId',
    MEETING_OVERVIEW_TEMPLATES_CREATE_PERSONAL = '/meetings/templates/create-personal',
    MEETING_OVERVIEW_TEMPLATES_CREATE_COMPANY = '/meetings/templates/create-company',
    MEETING_OVERVIEW_SHARED = '/meetings/shared',
    MEETING_OVERVIEW_TEAM_INSIGHTS = '/meetings/team',
    MEETING_OVERVIEW_COMPANY_INSIGHTS = '/meetings/company',
    MEETING_DEDICATED = '/meeting/:meetingId',
    MEETING_SHARED = '/meetings/shared/:userIds',
    MEETING_SHARED_DEDICATED = '/meetings/shared/meeting/:meetingId',
    MEETING_TEMPLATES_CREATE = '/meetings/template/create',
    MEETING_TEMPLATES_EDIT = '/meetings/template/:templateId',
    NOTIFICATIONS_PAGE = '/notifications',
    OBJECTIVES = '/objectives',
    OBJECTIVES_YOUR = '/objectives/your',
    OBJECTIVES_TEAM = '/objectives/team',
    OBJECTIVES_TEAM_BROWSE = '/objectives/team/browse',
    OBJECTIVES_TEAM_LIST = '/objectives/team/list',
    OBJECTIVES_TEAM_CYCLES = '/objectives/team/cycles',
    OBJECTIVES_TEAM_CYCLE = '/objectives/team/cycles/:cycleId',
    OBJECTIVES_COMPANY = '/objectives/company',
    OBJECTIVES_COMPANY_LIST = '/objectives/company/list',
    OBJECTIVES_COMPANY_BROWSE = '/objectives/company/browse',
    OBJECTIVES_COMPANY_HIERARCY = '/objectives/company/hierarchy',
    OBJECTIVES_COMPANY_CASCADE = '/objectives/company/cascade',
    OBJECTIVES_COMPANY_CYCLES = '/objectives/company/cycle',
    OBJECTIVES_COMPANY_CYCLE = '/objectives/company/cycle/:cycleId',
    OBJECTIVE_CYCLE_CREATE = '/objectives/company/cycle/create',
    OBJECTIVE_CYCLE_EDIT = '/objectives/company/cycle/edit/:cycleId',
    OBJECTIVE_CYCLE_COPY = '/objectives/company/cycle/copy/:cycleId',
    OBJECTIVE_SINGLE = '/objectives/:cycleId/:objectiveId',
    OBJECTIVE_SINGLE_BY_ID = '/objective/:id',
    OBJECTIVE_CLONE = '/objective/:id/clone',
    OBSERVER_COMPANY = '/observer/companies',
    OBSERVER_COMPANY_USER = '/observer/companies/:companyId/users',
    OBSERVER_USER = '/observer/users',
    OBSERVER_COMPANY_PAGE = '/observer/company/:companyId',
    OBSERVER_SOURCE_STATS = '/observer/usage-source-stats',
    OBSERVER_BILLING_COMPANY = '/observer/billing/:companyId',
    OBSERVER_EXPERIMENT = '/observer/experiments',
    OBSERVER_EXPERIMENT_CREATE = '/observer/experiments/create',
    OBSERVER_EXPERIMENT_VIEW = '/observer/experiments/:codeId',
    OBSERVER_AI_COACH = '/observer/ai-coach',
    OBSERVER_AI_COACH_HISTORY = '/observer/ai-coach/history',
    OBSERVER_AI_COACH_PROMPT = '/observer/ai-coach/prompt',
    OBSERVER_FEATURES = '/observer/features',
    OBSERVER_FEATURES_BULK_TOGGLE = '/observer/features/:featureId',
    OBSERVER_CUSTOMER_HEALTH = '/observer/customer-health',
    OBSERVER_CUSTOMER_HEALTH_COMPANY = '/observer/customer-health/:companyId',
    OBSERVER_SURVEY = '/observer/surveys/:surveyId',
    OBSERVER_USERS_TO_EMAILS = '/observer/users-to-emails',
    PERSONAL_ACCESS_TOKENS = '/personal-access-tokens',
    REVIEWS = '/reviews',
    REVIEWS_YOUR = '/reviews/your',
    REVIEWS_TEAM = '/reviews/team',
    REVIEWS_TEAM_CYCLE = '/reviews/team/:cycleId',
    REVIEWS_COMPANY = '/reviews/company',
    REVIEWS_COMPANY_TEMPLATES = '/reviews/company/templates',
    REVIEWS_COMPANY_CYCLE = '/reviews/company/:cycleId',
    REVIEWS_COMPANY_COMPARE_CYCLES = '/reviews/company/compare',
    REVIEWS_COMPANY_CYCLE_CREATE = '/reviews/company/create',
    REVIEWS_COMPANY_CYCLE_COPY = '/reviews/company/copy/:cycleId',
    REVIEWS_COMPANY_CYCLE_EDIT = '/reviews/company/edit/:cycleId',
    REVIEW_EDIT = '/reviews/edit/:reviewId',
    REVIEW_VIEW = '/reviews/view/:reviewId',
    REVIEW_PREVIEW_QUESTIONNAIRE = '/reviews/preview/questionnaire/:cycleId',
    REVIEW_GRAPH_TEAM_WITH_CYCLE = '/reviews/graph/team/:managerId/:cycleId',
    USER_EDIT = '/users/edit',
    USER_PROFILE = '/user/:id',
    USER_EXPORT_DATA = '/user/:id/export-data',
    USER_CHANGE_PASSWORD = '/user/:id/change-password',
    USER_SETTINGS = '/user-settings',
    USER_PROFILE_SHORT = '/user',
    YOUR_SURVEYS = '/surveys',
    YOUR_SURVEYS_YOUR = '/surveys/your',
    YOUR_SURVEYS_ANSWER_SURVEY = '/surveys/answer/:surveyInstanceId',
    YOUR_SURVEYS_SHARED = '/surveys/shared',
    YOUR_SURVEYS_SHARED_WITH_SURVEY = '/surveys/shared/:surveyId',
    YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT = '/surveys/shared/:surveyId/print',
    YOUR_SURVEYS_COMPANY = '/surveys/company',
    YOUR_SURVEYS_COMPANY_WITH_SURVEY = '/surveys/company/:surveyId',
    YOUR_SURVEYS_COMPANY_CREATE = '/surveys/company/create',
    YOUR_SURVEYS_COMPANY_EDIT = '/surveys/company/edit/:surveyId',
    YOUR_SURVEYS_COMPANY_COPY = '/surveys/company/copy/:surveyId',
    YOUR_SURVEYS_COMPANY_WITH_SURVEY_PRINT = '/surveys/company/:surveyId/print',
    PEOPLE = '/people',
    PEOPLE_TEAM = '/people/team',
    PEOPLE_TEAM_USER = '/people/team/:userId',
    PEOPLE_DIRECTORY = '/people/directory',
    PEOPLE_DIRECTORY_CREATE = '/people/directory?create',
    PEOPLE_ACTIVITES = '/people/activities',
    PEOPLE_MESSAGES = '/people/messages',
    COMING_SOON = '/coming-soon',
    COMING_SOON_FEATURE = '/coming-soon/:featureId',
    ADMIN_MEETINGS = '/admin/meetings',
    ADMIN_MEETINGS_INSIGHTS = '/admin/meetings/insights',
    ADMIN_MEETINGS_SETTINGS = '/admin/meetings/settings',
    ADMIN_MEETINGS_EMAILS = '/admin/meetings/emails',
    ADMIN_MEETINGS_TEMPLATES = '/admin/meetings/templates',
    ADMIN_MEETINGS_TEMPLATES_CREATE = '/admin/meetings/templates/create',
    ADMIN_MEETINGS_TEMPLATES_EDIT = '/admin/meetings/templates/:templateId',
    ADMIN_PRAISE = '/admin/praise',
    ADMIN_PRAISE_EMAILS = '/admin/praise/emails',
    ADMIN_SURVEYS = '/admin/surveys',
    ADMIN_SURVEYS_WITH_SURVEY = '/admin/surveys/:surveyId',
    ADMIN_SURVEYS_WITH_SURVEY_PRINT = '/admin/surveys/:surveyId/print',
    ADMIN_SURVEYS_CREATE = '/admin/surveys/create',
    ADMIN_SURVEYS_EDIT = '/admin/surveys/edit/:surveyId',
    ADMIN_SURVEYS_COPY = '/admin/surveys/copy/:surveyId',
    ADMIN_OBJECTIVES_SELECT_CYCLE = '/admin/objectives',
    ADMIN_OBJECTIVES_CYCLE_OVERVIEW = '/admin/objectives/:cycleId',
    ADMIN_OBJECTIVES_EMAILS = '/admin/objectives/emails',
    ADMIN_FEEDBACK_SELECT_CYCLE = '/admin/feedback',
    ADMIN_FEEDBACK_WITH_CYCLE = '/admin/feedback/:cycleId',
    ADMIN_FEEDBACK_CYCLE_CREATE = '/admin/feedback/create',
    ADMIN_FEEDBACK_CYCLE_EDIT = '/admin/feedback/edit/:cycleId',
    ADMIN_FEEDBACK_CYCLE_COPY = '/admin/feedback/copy/:cycleId',
    ADMIN_FEEDBACK_TEMPLATES = '/admin/feedback/templates',
    ADMIN_FEEDBACK_REQUESTED = '/admin/feedback-requests',
    ADMIN_FEEDBACK_REQUESTED_TEMPLATES = '/admin/feedback-requests/templates',
    ADMIN_FEEDBACK_REQUESTED_SETTINGS = '/admin/feedback-requests/settings',
    ADMIN_FEEDBACK_REQUESTED_EMAILS = '/admin/feedback-requests/emails',
    ADMIN_FEEDBACK_REQUESTED_AUTOMATIONS = '/admin/feedback-requests/automations',
    ADMIN_FEEDBACK_EMAILS = '/admin/feedback/emails',
    ADMIN_REVIEWS_SELECT_CYCLE = '/admin/reviews',
    ADMIN_REVIEWS_QUESTIONNAIRES = '/admin/reviews/questionnaires',
    ADMIN_REVIEWS_WITH_CYCLE = '/admin/reviews/:cycleId',
    ADMIN_REVIEWS_COMPARE_CYCLES = '/admin/reviews/compare',
    ADMIN_REVIEW_CYCLE_CREATE = '/admin/reviews/create',
    ADMIN_REVIEW_CYCLE_EDIT = '/admin/reviews/edit/:cycleId',
    ADMIN_REVIEW_CYCLE_COPY = '/admin/reviews/copy/:cycleId',
    ADMIN_REVIEW_GRAPH_WITH_CYCLE = '/admin/reviews/graph/:cycleId',
    ADMIN_REVIEWS_EMAILS = '/admin/reviews/emails',
    ADMIN_USERS_DIRECTORY = '/admin/directory',
    ADMIN_USERS_DIRECTORY_CREATE = '/admin/directory?create',
    ADMIN_MESSAGES = '/admin/messages',
    ADMIN_MESSAGES_EMAILS = '/admin/messages/emails',
    ADMIN_DASHBOARD = '/admin/home',
    ADMIN_INTEGRATIONS = '/admin/integrations',
    ADMIN_EARLY_ACCESS = '/admin/early-access',
    ADMIN_EARLY_ACCESS_FEATURE = '/admin/early-access/:featureId',
    COMPANY_ONBOARDING_DEMOGRAPHIC = '/onboarding-survey/',
    COMPANY_ONBOARDING_ORIGIN = '/onboarding-survey/origin/',
    COMPANY_ONBOARDING_INTEREST = '/onboarding-survey/interestsettings/',
    COMPANY_ONBOARDING_HRIS = '/onboarding-survey/hris',
    COMPANY_ONBOARDING_DONE = '/onboarding-survey/done',
    AI_COACH = '/ai-coach',
    AI_COACH_CHAT = '/ai-coach/workspace',
    AI_COACH_CHAT_NEW = '/ai-coach/workspace/new',
    AI_COACH_CHAT_HISTORY = '/ai-coach/workspace/:chatId';
